import { API } from '@/api';
import axios from 'axios';

const state = {
  admin: null,
};
// https://developer.mozilla.org/en-US/docs/Web/API/Window/sessionStorage
const getters = {
  // getAdmin: (State) => JSON.parse(window.sessionStorage.getItem('administracion')),
  getAdmin: (State) => {
    if (state.admin !== null) {
      return state.admin;
    } else if (typeof window.sessionStorage.getItem('administracion') === 'string') {
      state.admin = JSON.parse(window.sessionStorage.getItem('administracion') || 'null');
      return state.admin;
    } else {
      console.error('Error parsing window.sessionStorage.getItem("administracion")');
      return null;
    }
  },
};
const actions = {
  async getAdminList({ commit, State }, options) {
    const sortBy = options.sortBy[0] ? options.sortBy[0] + ',' + (options.sortDesc[0] ? 'desc' : 'asc') : '';
    const queryString = {page: options.page - 1, size: options.itemsPerPage, sort: sortBy};
    console.debug('queryString: %o', queryString);
    const response = await API.get('/admin/list', {params: queryString});
    console.debug('Administraciones: %o', response.data);
    return response.data;
  },
  async getAdminById({ commit, State }, admin) {
    const response = await API.get('/admin/get/' + admin.id);
    return response.data;
  },
  async addAdmin({ commit, State }, admin) {
    const response = await API.post('/admin/add/', admin);
    return response.data;
  },
  async modifyAdmin({ commit, State }, admin) {
    const response = await API.post('/admin/' + admin.id + '/modify', admin);
    return response.data;
  },
  setAdmin({ commit, State }, admin) {
    commit('setAdmin', admin);
  },
  clearAdmin({ commit, State }) {
    commit('clearAdmin');
  },
};
const mutations = {
  setAdmin: (State, admin) => {
      State.admin = admin;
      window.sessionStorage.setItem('administracion', JSON.stringify(admin));
  },
  clearAdmin: (State) => {
    State.admin = null;
    window.sessionStorage.removeItem('administracion');
  },
};

export default {
  actions,
  mutations,
  getters,
  state,
};
